import { formatPrice } from '@payaca/helpers/financeHelper';
import { CurrencyValue as TCurrencyValue } from '@payaca/types/currencyTypes';

const f = formatPrice(navigator.language);

/** For formatting inside a callback, where the hook can't be called. */
export const formatPreferredCurrency = (args: TCurrencyValue) => {
  const { value, currency } = args;

  return f({
    priceInMinorCurrencyUnits: value,
    exponent: currency.exponent,
    currencyCode: currency.code,
  });
};

const usePreferredCurrencyFormat = (args: TCurrencyValue) =>
  formatPreferredCurrency(args);

export default usePreferredCurrencyFormat;
